import { render } from "./PublicLayout.vue?vue&type=template&id=9a806b58&scoped=true"
const script = {}

import "./PublicLayout.vue?vue&type=style&index=0&id=9a806b58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a806b58"]])

export default __exports__